"use client";
import type {
  OPTIMIZELY_FEATURE_FLAGS,
  OPTIMIZELY_FEATURE_VARIABLES
} from "analytics/optimizely/config";
import React from "react";

export type FeatureFlags = Partial<Record<OPTIMIZELY_FEATURE_FLAGS, boolean>>;

export type FeatureVariablesType = Partial<{
  [K in OPTIMIZELY_FEATURE_FLAGS]?: Partial<{
    [V in OPTIMIZELY_FEATURE_VARIABLES]?: any;
  }>;
}>;

export type FeatureFlagContextType = {
  featureFlags: FeatureFlags;
  featureVariables?: FeatureVariablesType;
};

export const FeatureFlagContext = React.createContext<FeatureFlagContextType>({
  featureFlags: {},
  featureVariables: {}
});

// React.FC is not working, so I manually added the children prop
export const FeatureFlagProvider = ({
  featureFlags,
  children,
  featureVariables
}: {
  featureFlags: FeatureFlags;
  featureVariables?: FeatureVariablesType;
  children?: React.ReactNode;
}) => {
  if (featureFlags === null || typeof featureFlags !== "object") {
    console.error("The featureFlags prop must be an object.");
  }
  return (
    <FeatureFlagContext.Provider value={{ featureFlags, featureVariables }}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export function useFeatureFlags(): FeatureFlagContextType {
  const context = React.useContext(FeatureFlagContext);
  if (context === undefined) {
    throw new Error(
      "useFeatureFlags must be used within a FeatureFlagProvider"
    );
  }
  return context;
}
